import moment from 'moment'

moment.locale('zh-cn', {
  meridiem: function(hour, minute, isLowercase) {
    if (hour < 9) {
      return '早上'
    } else if (hour < 11 && minute < 30) {
      return '上午'
    } else if (hour < 13 && minute < 30) {
      return '中午'
    } else if (hour < 18) {
      return '下午'
    } else {
      return '晚上'
    }
  },
})

export const pwdType = function(val) {
  const dict = {
    TEMP: '看房密码',
    NORMAL: '租客密码',
    DYNAMIC: '离线密码',
    CUSTOM: '自定义密码',
    SHORTPWD: '短租密码',
    MOVEHOME: '搬家密码',
    OFFLINE: 'APP离线开门',
    PWD: '密码开门'
  }

  return dict[val]
}
export const newLookPwdType = function(val) {
  const dict = {
    TEMP: '看房授权',
    NORMAL: '租客授权',
    CUSTOM: '自定义授权',
    MOVEHOME: '搬家授权',
    OFFLINE: 'APP离线开门',
    PWD: '密码开门',
    TEMPORARY: '临时授权',
    DYNAMIC: '离线密码',
    SHORTPWD: '短期密码',
    MOVEOUT: '搬出授权',
    EMERGENCY: '应急密码',
    ACC: '同住人授权'
  }

  return dict[val]
}
export const newLookBusinessType = function(val) {
  const dict = {
    NEW_NORMAL_AUTH: '添加租客授权',
    NEW_TEMP_AUTH: '添加看房授权',
    NEW_CUSTOM_AUTH: '添加自定义授权',
    NEW_EMERGENCY_PWD: '添加应急密码',
    ISSUE_AUTHORIZATION: '发放授权',
    WITHDRAW_AUTHORIZATION: '收回授权',
    NEW_CUSTOM_PWD: '添加自定义密码',
    DEL_PWD: '删除密码',
    NEW_NORMAL_PWD: '添加租客密码',
    NEW_TEMP_PWD: '添加临时密码',
    NEW_DYNAMIC_PWD: '添加动态密码',
    UPDATE_PWD: '修改密码',
    FETCH_PWD: '查询密码',
    FROZEN_PWD: '冻结密码',
    UNFROZEN_PWD: '解冻密码',
    SEND_PWD: '发送密码',
    DelInvalidPwd: '删除失效密码',
    ISSUE_AUTHORIZATION_ERROR: '发放授权失败',
    WITHDRAW_AUTHORIZATION_ERROR: '收回授权失败'
  }

  return dict[val]
}

// 账单的状态过滤
export const payStatus = function(val) {
  const dict = {
    NEW: '未支付',
    PAYING: '支付中',
    SUC: '支付成功',
    FAIL: '支付失败',
    PDOFF: '线下已支付',
    MER: '已被合并',
    SPL: '已被分拆',
    RETURNING: '返还中',
    RET: '已返还',
    NOT_RETURN: '不需要返还',
    CF: '已结转',
    // DEL: '已删除',
    CONFIRM: '已确认',
    MAKE_BILLS: '已制单',
    AUDIT_BILLS: '已复核',
    ISSUED: '已开发票',
    PARTPAID: '分拆后部分已支付',
    FULLYPAID: '分拆后全部已支付',
    CUR_SPL_CONF: '部分分拆生成订单已确认',
    ALL_SPL_CONF: '全部分拆生成订单已确认',
    MERGEDPAID: '合并后总订单已支付',
    MER_CONF: '合并后总账单已确认',
    ALREADY_CANCEAL: '已取消',
    // REFUNDED: '已退款'
    REFUNDED: '打款失败',
    WAIT_AUDITED: '待审核',
    DEL: '已取消',
    WAIT_BILLS: '待制单',
  }
  return dict[val]
}
// 账单的金额类型过滤
export const moneyType = function(val) {
  // const dict = {
  //   REN: '租金',
  //   WATER: '冷水费',
  //   HOT_WATER: '热水费',
  //   ELEC: '电费',
  //   GAS: '燃气费',
  //   COM: '赔偿',
  //   MAIN: '维修',
  //   CLEAN: '保洁',
  //   CONSUME: '消费',
  //   PERFEE: '物管费',
  //   NETWORK: '网费',
  //   MANAGECOST: '手续费',
  //   AC_COST: '空调费',
  //   ONECARD: '一卡通费用',
  //   LATEFEE: '滞纳金',
  //   OTH: '其他费用',
  //   CHANGE_FEE: '换房费用',
  //   SUBLET_FEE: '转租费用',
  //   CANCEL_FEE: '退租费用',
  //   OLD_TO_NEW: '老带新',
  // }
  const dict = {
    REN: '租金',
    WATER: '冷水费',
    HOT_WATER: '热水费',
    ELEC: '电费',
    GAS: '燃气费',
    COM: '赔偿',
    MAIN: '维修',
    CLEAN: '保洁',
    CONSUME: '消费',
    PERFEE: '物管费',
    NETWORK: '网费',
    MANAGECOST: '手续费',
    AC_COST: '空调费',
    ZH_ENERGY: '综合能耗费',
    ZH_WATER: '冷水费',
    ZH_HOT_WATER: '热水费',
    ZH_ELEC: '电费',
    ZH_GAS: '燃气费',
    ZH_AC_COST: '空调费',
    ZH_SECOP: '物管(楼/户外)公摊能耗费',
    ZH_BISEC: '楼/户内公摊能耗费',
    ZH_EMC: '设备维养费',
    ONECARD: '一卡通费用',
    LATEFEE: '滞纳金',
    OTH: '其他费用',
    CHANGE_FEE: '换房费用',
    SUBLET_FEE: '转租费用',
    CANCEL_FEE: '退租费用',
    OLD_TO_NEW: '老带新',
  }
  return dict[val] || val
}

// 订单状态
export const orderStatus = function(val) {
  const dict = {
    NEW: '未支付',
    PAYING: '支付中',
    SUC: '支付成功',
    FAIL: '支付失败',
    PDOFF: '线下已支付',
    PDON: '线上直接转账已支付',
    PARTPAID: '分拆后部分已支付',
    FULLYPAID: '分拆后全部已支付',
    MERGEDPAID: '合并后总订单已支付',
    MER: '已被合并',
    SPL: '已被分拆',
    RETURNING: '返还中',
    NOT_RETURN: '不需要返还',
    RET: '已返还',
    CF: '已结转',
    DEL: '已删除',
    CONFIRM: '已确认',
    ISSUED: '已开发票',
    CUR_SPL_CONF: '部分分拆生成订单已确认',
    ALL_SPL_CONF: '全部分拆生成订单已确认',
    MER_CONF: '总账单已确认',
  }

  return dict[val]
}
// 下个状态提示
// export const nextStatus = function(val) {
//   const mapping = {
//     NEW: '制单',
//     REFUNDED: '打款',
//     MAKE_BILLS: '复核',
//     AUDIT_BILLS: '打款',
//   }
//   return mapping[val]
// }
export const couponMoneyType = val => {
  const dict = {
    OLD_TO_NEW: '老带新代金券',
    DISCOUNT: '抵扣券',
  }
  return dict[val] || ''
}
export const financeType = function(val) {
  const dict = {
    INC: '',
    PAY: '',
    DISC: '抵扣',
    DESP: '押金',
    EARNEST: '定金',
  }

  return dict[val]
}

export const incAndExpense = val => {
  const dict = {
    INC: '收款',
    PAY: '退款',
    DISC: '退款',
    DESP: '收款(押金)',
  }
  return dict[val]
}

// 账单的支付方式过滤
export const payMethod = function(val) {
  const dict = {
    ALIPAY: '支付宝',
    WECHAT: '微信支付',
    UNION: '银联',
    WALLET: '钱包支付',
    EBANK: '网银',
    CASH: '线下现金支付',
    H5ALIPAY: '网页版支付宝',
    H5WECHAT: '网页版微信',
    ALIQRCODE: '支付宝二维码',
    SYSTEMIMPORT: '系统导入'
  }
  return dict[val]
}

// 证件信息
export const certType = function(val) {
  if (!val) return '暂无信息'
  const dict = {
    ID: '身份证',
    P: '护照',
    DL: '驾驶执照',
    BL: '工商营业执照',
    HK: '港澳通行证',
    TW: '台湾通行证',
  }
  return dict[val]
}
export const dateFormat = function(val, separator = '-') {
  if (!val) return '暂无信息'
  let dateArr = ['YYYY', 'MM', 'DD']
  return moment(val).format(dateArr.join(separator))
}
/*
 *  标准的时间对象转换为字符串
 *  @author zhangbing
 *  @param {Number} val 需要过滤的值,一般是毫秒数
 *  @param {String} separator 日期的分割符号，默认.
 */

export const date = function(val, separator = '-') {
  if (!val) return ''
  let dateArr = ['YYYY', 'MM', 'DD']
  return moment(val).format(dateArr.join(separator))
}

/*
 *  标准的时间对象转换为字符串,格式为 2017/02/05 上午9：17：12
 *  @author zhangbing
 *  @param {Number} val 需要过滤的值,一般是毫秒数
 *  @param {String} separator 日期的分割符号，默认/
 */
export const dateTime = function(val, separator) {
  if (!val) return ''
  let standStr = separator || '-'
  let standDate = new Date(val)
  let year = standDate.getFullYear()
  let mon = standDate.getMonth() + 1
  if (mon < 10) {
    mon = '0' + mon
  }
  let day = standDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  let dateStr = year + standStr + mon + standStr + day
  let hour = standDate.getHours()
  if (hour < 10) {
    hour = '0' + hour
  }
  let min = standDate.getMinutes()
  if (min < 10) {
    min = '0' + min
  }
  let sec = standDate.getSeconds()
  if (sec < 10) {
    sec = '0' + sec
  }
  return dateStr + ' ' + hour + ':' + min + ':' + sec
}

// 支付方式
export const payCycle = function(val) {
  const dict = {
    ONEMON: '月付',
    THREEMON: '季付',
    SIXMON: '半年付',
    TWELVEMON: '年付',
    ONEPAY: '一次性付清',
    TWOMON: '二月一付',
    FOURMON: '四月一付',
    GYIRRE: '顾寓不规则计费',
    ONETIME: '一次性收费',
    JZONE: '结转的一次性付清',
  }
  return dict[val]
}

export const platformType = function(val) {
  const dict = {
    W: '58月付',
    H: '会分期',
    G: '工行分期',
    Z: '租了么',
  }
  return dict[val]
}
// 证件类型
export const certificateType = function(val) {
  const dict = {
    ID: '身份证',
    P: '护照',
    DL: '驾驶执照',
    BL: '工商营业执照',
    HK: '港澳通行证',
    TW: '台湾通行证',
  }
  return dict[val]
}
// 权属证件类型
export const ownershipType = function(val) {
  const dict = {
    OWNERSHIPCERTIFICATE: '房屋所有权证',
    LANDCERTIFICATE: '土地证',
    LANDUSEAPPROVAL: '用地批文',
    RESETTLEMENTAGREEMENT: '安置协议',
    RULINGDOCUMENT: '裁定文书',
    REALESTATECERTIFICATE: '不动产权证书',
    PRE_SELL: '预售证书',
    DRAW_NOTIFY: '抽签通知证书',
    OTHER: '其他',
  }
  return dict[val]
}
/** 权属证件文件翻译字典 */
export const attachmentList = {
  OWNERSHIPHOTO: '房屋信息',
  CERTIFICATES: '身份证',
  ENTRUSTMENT: '委托协议',
  LAYOUTIMAGE: '户型图'
}
export const houseOwnershipCertificateType = function(val) {
  const dict = {
    OFFICIAL: '房屋所有权证书',
    PRE_SELL: '预售证书',
    DRAW_NOTIFY: '抽签通知证书',
    OTHER: '其他',
  }
  return dict[val]
}

// 续租类型枚举
export const renewalTypes = val => {
  const dict = {
    OLDRENEWAL: '原房续租',
    NEWRENEWAL: '换房续租',
  }
  return dict[val] || ''
}
// 租期时长
export const reletTimeRange = val => {
  const dict = {
    DAY: '天',
    MONTH: '个月',
    FD_END: '房东合同到期日',
    FD_BEFORE_ONE: '房东合同到期日前一个月',
    FD_AFTER_ONE: '房东合同到期日后一个月',
    FD_AFTER_TWO: '房东合同到期日后两个月',
    FD_AFTER_THREE: '房东合同到期后三个月',
  }
  return dict[val] || '无'
}
// 时间格式转换
export const timeChange = function(val) {
  if (!val) return ''
  const timer = new Date(val)
  const year = timer.getFullYear()
  var month = timer.getMonth() + 1
  month = month < 10 ? '0' + month : month
  var date = timer.getDate()
  date = date < 10 ? '0' + date : date
  const stringTime = year + '/' + month + '/' + date
  return stringTime
}

export const changeTimeType = val => {
  if (!val) {
    return ''
  }
  var timer = val
  timer = new Date(timer)
  // console.log(timer)
  const year = timer.getFullYear()
  var month = timer.getMonth() + 1
  month = month < 10 ? '0' + month : month
  var date = timer.getDate()
  date = date < 10 ? '0' + date : date
  const stringTime = year + '-' + month + '-' + date
  return stringTime
}

export const tenantType = val => {
  const dict = {
    SUIYU_WORKER: '随寓员工',
    DEXIN_WORKER: '德信员工',
    OFFICIAL_WORKER: '工作人员',
    COMMON: '普通用户',
  }
  return dict[val] || val
}
// 去除 字符串两端空格
export const removeBlank = val => {
  return val.replace(/^\s*|\s*$/g, '')
}
// todo :将不同业务中的过滤器进行分模块维护 @zhangbing
// hanpan517 - 费用类型筛选
// payPurposeType 费用类型
export const payPurposeType = val => {
  const dict = {
    REN: '租金',
    REN_DESP: '押金',
    WATER: '冷水费',
    HOT_WATER: '热水费',
    ZH_ELEC: '电费',
    ZH_GAS: '燃气费',
    ZH_AC_COST: '空调费',
    ZH_SECOP: '物管(楼/户外)公摊能耗费',
    ZH_BISEC: '楼/户内公摊能耗费',
    ZH_EMC: '设备维养费',
    ELEC: '电费',
    GAS: '燃气费',
    COM: '赔偿',
    MAIN: '维修',
    CLEAN: '保洁',
    CONSUME: '消费',
    PERFEE: '物管费',
    NETWORK: '网络费',
    MANAGECOST: '手续费',
    AC_COST: '空调费',
    ONECARD: '一卡通',
    OTH: '其他费用',
    CHANGE_FEE: '换房费用',
    SUBLET_FEE: '转租费用',
    CANCEL_FEE: '退租费用',
    OLD_TO_NEW: '老带新',
    LATEFEE: '滞纳金',
    ZH_ENERGY: '综合能耗费',
    ZH_WATER: '冷水费',
    ZH_HOT_WATER: '热水费',
  }
  return dict[val] || val
}
// payPurposeTypeDelete 电费子账单
export const payPurposeTypeDelete = val => {
  const dict = {
    ZH_SECOP: '物管(楼/户外)公摊能耗费',
    ZH_BISEC: '楼/户内公摊能耗费',
    ZH_EMC: '设备维养费',
  }
  return dict[val] || null
}
// payPurposeTypeDelete 电费子账单及电费
export const payPurposeTypeDeletePlus = val => {
  const dict = {
    ZH_ELEC: '电费',
    ZH_SECOP: '物管(楼/户外)公摊能耗费',
    ZH_BISEC: '楼/户内公摊能耗费',
    ZH_EMC: '设备维养费',
  }
  return dict[val] || null
}
// payPurposeTypeDetails 是否是综合能耗费
export function payPurposeTypeDetails(val) {
  const dict = {
    ZH_ENERGY: '综合能耗费',
    ZH_WATER: '冷水费',
    ZH_HOT_WATER: '热水费',
    ZH_ELEC: '电费',
    ZH_GAS: '燃气费',
    ZH_AC_COST: '空调费',
    ZH_SECOP: '物管(楼/户外)公摊能耗费',
    ZH_BISEC: '楼/户内公摊能耗费',
    ZH_EMC: '设备维养费',
  }
  return dict[val] || null
}



// WEBPACK FOOTER //
// ./src/filters/index.js